import React, { Component } from 'react';
import { shape, bool, arrayOf, string } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';

import { operations as segmentCreationOperations } from 'state/ducks/segmentCreation';
import { operations as mapOperations } from 'state/ducks/map';

import locationShape from 'propTypes/locationShape';
import coord from 'propTypes/coord';

import LoadingIndicator from 'components/LoadingIndicator';
import filterAvailableLocations from 'helpers/filterAvailableLocations';
import LocationMarkerGroup from './LocationMarkerGroup';
import SegmentGroup from './SegmentGroup';

import styles from './CreateSegment.scss';

const CreateSegmentMapQuery = gql`
  query CreateSegmentMap {
    locations {
      id
      lat
      lng
      name
      trackingDevice {
        id
        name
        status
        batteryVoltage
        temperature
        reportInterval
        lastUpdate
        numberOfHitsToday
      }
    }
    segments {
      id
      path
      bounds
      from {
        id
        name
      }
      to {
        id
        name
      }
    }
  }
`;

class CreateSegmentMap extends Component {
  componentWillUpdate(nextProps) {
    const { data: { locations }, setAllFeatureBounds } = nextProps;

    /* only update bounds on first data render */
    if (this.props.data.loading && !nextProps.loading) {
      const bounds = locations.reduce((acc, v) => [...acc, [v.lat, v.lng]], []);
      setAllFeatureBounds(bounds);
    }
  }

  render() {
    const {
      data: { loading, locations, segments },
      pathSuggestions,
      selectedPathSuggestion,
      createdSegmentId,
      selectedLocations,
    } = this.props;

    if (loading) {
      return <LoadingIndicator />;
    }

    const showPathSuggestions = Boolean(pathSuggestions && pathSuggestions.length > 0);
    const isFlowFinished = Boolean(createdSegmentId);

    // These locations should be allowed to receive click events
    const validNextLocations = filterAvailableLocations(locations, segments, selectedLocations);

    return (
      <div className={styles.main}>
        <LocationMarkerGroup
          locations={locations}
          disableInteraction={isFlowFinished}
          validNextLocations={validNextLocations}
        />
        <SegmentGroup
          segments={segments}
          showPathSuggestions={showPathSuggestions}
          pathSuggestions={Boolean(pathSuggestions) && pathSuggestions}
          selectedPathSuggestion={Boolean(selectedPathSuggestion) && selectedPathSuggestion}
          disableInteraction={isFlowFinished}
        />
      </div>
    );
  }
}

CreateSegmentMap.propTypes = {
  data: shape({
    loading: bool.isRequired,
    locations: arrayOf(locationShape),
    segments: arrayOf(
      shape({
        id: string,
        path: arrayOf(coord),
        from: locationShape,
        to: locationShape,
      })
    ),
  }).isRequired,
  pathSuggestions: arrayOf(shape({})),
  selectedPathSuggestion: shape({ id: string }),
  createdSegmentId: string,
  selectedLocations: arrayOf(string),
};

const mapStateToProps = ({ map, segmentCreation }) => ({
  viewMode: map.viewMode,
  selectedLocations: segmentCreation.selectedLocations,
  pathSuggestions: segmentCreation.pathSuggestions,
  createdSegmentId: segmentCreation.createdSegmentId,
  selectedPathSuggestion: segmentCreation.selectedPathSuggestion,
});

const ConnectedCreateSegmentMapWithData = compose(
  connect(mapStateToProps, { ...mapOperations, ...segmentCreationOperations }),
  graphql(CreateSegmentMapQuery, {})
)(CreateSegmentMap);

export default ConnectedCreateSegmentMapWithData;



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/index.js